module.exports = __webpack_public_path__ + "img/231a0e1.png";